import Vue from 'vue';
import Router from 'vue-router';
import {ROUTE_NAME} from '@/constants/constants';


const TheDashboard = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/TheDashboard'], () => {
    resolve(require('@/views/TheDashboard'))
  })
};


const TheDashboardAbnormalDetail = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/TheDashboard'], () => {
    resolve(require('@/views/TheAbnormalDetail'))
  })
};


const TheDashboardAbnormalList = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/TheDashboard'], () => {
    resolve(require('@/views/TheAbnormalList'))
  })
};


const TheDashboardShare = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/share/TheDashboardShare'], () => {
    resolve(require('@/views/share/TheDashboardShare'))
  })
};

const TheBilling = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/TheBilling'], () => {
    resolve(require('@/views/TheBilling'))
  })
};

const TheCostAnalytics = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/TheCostAnalytics'], () => {
    resolve(require('@/views/TheCostAnalytics'))
  })
};

const TheSavingsPlansIndex = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/savings-plans/TheSavingsPlansIndex'], () => {
    resolve(require('@/views/savings-plans/TheSavingsPlansIndex'))
  })
};


const TheSavingsPlansCoverage = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/savings-plans/TheSavingsPlansCoverage'], () => {
    resolve(require('@/views/savings-plans/TheSavingsPlansCoverage'))
  })
};

const TheSavingsPlansUtilization = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/savings-plans/TheSavingsPlansUtilization'], () => {
    resolve(require('@/views/savings-plans/TheSavingsPlansUtilization'))
  })
};

const TheSavingsPlansInventory = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/savings-plans/TheSavingsPlansInventory'], () => {
    resolve(require('@/views/savings-plans/TheSavingsPlansInventory'))
  })
};

const TheEc2RiRecommendation = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/reserved/TheEc2RiRecommendation'], () => {
    resolve(require('@/views/reserved/TheEc2RiRecommendation'))
  })
};

const TheOpnsrchRiRecommendation = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/reserved/TheOpnsrchRiRecommendation'], () => {
    resolve(require('@/views/reserved/TheOpnsrchRiRecommendation'))
  })
};

const TheRdsRiRecommendation = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/reserved/TheRdsRiRecommendation'], () => {
    resolve(require('@/views/reserved/TheRdsRiRecommendation'))
  })
};

const TheSavingsPlansRecommendation = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/savings-plans/TheSavingsPlansRecommendation'], () => {
    resolve(require('@/views/savings-plans/TheSavingsPlansRecommendation'))
  })
};

const TheMisOperationStatusIndex = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/mis-operation-status/TheMisOperationStatusIndex'], () => {
    resolve(require('@/views/mis-operation-status/TheMisOperationStatusIndex'))
  })
};

const TheCspOperationStatus = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/mis-operation-status/TheCspOperationStatus'], () => {
    resolve(require('@/views/mis-operation-status/TheCspOperationStatus'))
  })
};

const TheConvertCloudROI = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/mis-operation-status/TheConvertCloudROI'], () => {
    resolve(require('@/views/mis-operation-status/TheConvertCloudROI'))
  })
};

const TheReservedIndex = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/reserved/TheReservedIndex'], () => {
    resolve(require('@/views/reserved/TheReservedIndex'))
  })
};


const TheReservedCoverage = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/reserved/TheReservedCoverage'], () => {
    resolve(require('@/views/reserved/TheReservedCoverage'))
  })
};

const TheReservedUtilization = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/reserved/TheReservedUtilization'], () => {
    resolve(require('@/views/reserved/TheReservedUtilization'))
  })
};

const TheReservedInventory = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/reserved/TheReservedInventory'], () => {
    resolve(require('@/views/reserved/TheReservedInventory'))
  })
};

const TheAzureReservedIndex = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/azure-reserved/TheAzureReservedIndex'], () => {
    resolve(require('@/views/azure-reserved/TheAzureReservedIndex'))
  })
};

const TheAzureReservedInventory = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/azure-reserved/TheAzureReservedInventory'], () => {
    resolve(require('@/views/azure-reserved/TheAzureReservedInventory'))
  })
};

const TheAzureReservedUtilization = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/azure-reserved/TheAzureReservedUtilization'], () => {
    resolve(require('@/views/azure-reserved/TheAzureReservedUtilization'))
  })
};

const TheAzureReservedRianalysis = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/azure-reserved/TheAzureReservedRianalysis'], () => {
    resolve(require('@/views/azure-reserved/TheAzureReservedRianalysis'))
  })
};


const ThePageError = resolve => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(['@/views/page-error/ThePageError'], () => {
    resolve(require('@/views/page-error/ThePageError'))
  })
};

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkActiveClass: 'is-selected',
  routes: [
    {
      path: '/',
      redirect: {
        name: ROUTE_NAME.DASHBOARD,
      }
    },
    {
      path: '/dashboard',
      name: ROUTE_NAME.DASHBOARD,
      component: TheDashboard
    },
    {
      path: '/dashboard/anomaly-detail',
      name: ROUTE_NAME.ANOMALY_DETAIL,
      component: TheDashboardAbnormalDetail
    },
    {
      path: '/anomaly-detection',
      name: ROUTE_NAME.ANOMALY_LIST,
      component: TheDashboardAbnormalList
    },
    {
      path: '/dashboard/:uuid/:cmpnId/share',
      name: ROUTE_NAME.DASHBOARD_SHARE,
      component: TheDashboardShare,
      props: true
    },
    {
      path: '/dashboard/:uuid/share',
      name: ROUTE_NAME.DASHBOARD_SHARE,
      component: TheDashboardShare,
      props: true
    },
    {
      path: '/billing',
      name: ROUTE_NAME.BILLING,
      component: TheBilling,
    },
    {
      path: '/cost-analytics',
      name: ROUTE_NAME.COST_ANALYTICS,
      component: TheCostAnalytics,
      props: true
    },
    {
      path: '/savings-plans',
      name: ROUTE_NAME.SAVINGS_PLANS.INDEX,
      component: TheSavingsPlansIndex,
      props: true
    },
    {
      path: '/savings-plans/coverage',
      name: ROUTE_NAME.SAVINGS_PLANS.COVERAGE,
      component: TheSavingsPlansCoverage,
      props: true
    },
    {
      path: '/savings-plans/utilization',
      name: ROUTE_NAME.SAVINGS_PLANS.UTILIZATION,
      component: TheSavingsPlansUtilization,
      props: true
    },
    {
      path: '/savings-plans/inventory',
      name: ROUTE_NAME.SAVINGS_PLANS.INVENTORY,
      component: TheSavingsPlansInventory,
      props: true
    },
    {
      path: '/spoptm',
      name: ROUTE_NAME.SAVINGS_PLANS.RECOMMENDATION,
      component: TheSavingsPlansRecommendation,
      props: true
    },
    {
      path: '/reserved-instances',
      name: ROUTE_NAME.RESERVED.EC2_RECOMMENDATION,
      component: TheEc2RiRecommendation,
      props: true
    },
    {
      path: '/opnsrchrioptm',
      name: ROUTE_NAME.RESERVED.OPNSRCH_RECOMMENDATION,
      component: TheOpnsrchRiRecommendation,
      props: true
    },
    {
      path: '/rdsrioptm',
      name: ROUTE_NAME.RESERVED.RDS_RECOMMENDATION,
      component: TheRdsRiRecommendation,
      props: true
    },
    {
      path: '/mis-operation-status',
      name: ROUTE_NAME.MIS_OPERATION_STATUS.INDEX,
      component: TheMisOperationStatusIndex,
      props: true
    },
    {
      path: '/mis-operation-status/csp',
      name: ROUTE_NAME.MIS_OPERATION_STATUS.CSP,
      component: TheCspOperationStatus,
      props: true
    },
    {
      path: '/mis-operation-status/roi',
      name: ROUTE_NAME.MIS_OPERATION_STATUS.ROI,
      component: TheConvertCloudROI,
      props: true
    },
    {
      path: '/reservations',
      name: ROUTE_NAME.RESERVED.INDEX,
      component: TheReservedIndex,
      props: true
    },
    {
      path: '/reservations/coverage',
      name: ROUTE_NAME.RESERVED.COVERAGE,
      component: TheReservedCoverage,
      props: true
    },
    {
      path: '/reservations/utilization',
      name: ROUTE_NAME.RESERVED.UTILIZATION,
      component: TheReservedUtilization,
      props: true
    },
    {
      path: '/reservations/inventory',
      name: ROUTE_NAME.RESERVED.INVENTORY,
      component: TheReservedInventory,
      props: true
    },
    {
      path: '/azure-reservations',
      name: ROUTE_NAME.AZURE_RESERVED.INDEX,
      component: TheAzureReservedIndex,
      props: true
    },
    {
      path: '/azure-reservations/inventory',
      name: ROUTE_NAME.AZURE_RESERVED.AZUREINVENTORY,
      component: TheAzureReservedInventory,
      props: true
    },
    {
      path: '/azure-reservations/utilization',
      name: ROUTE_NAME.AZURE_RESERVED.AZUREUTILIZATION,
      component: TheAzureReservedUtilization,
      props: true
    },
    {
      path: '/azure-reservations/rirecommend',
      name: ROUTE_NAME.AZURE_RESERVED.AZURERIANALYSIS,
      component: TheAzureReservedRianalysis,
      props: true
    },
    {
      path: '*',
      name: 'ThePageError',
      component: ThePageError
    }
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js